<div class="bodyContent">
    <app-profile-summary title="{{summaryTitle}}" firstSectionText="{{summaryPart1}}" secondSectionText="{{summaryPart2}}" linkToCode="{{linkToCode}}"></app-profile-summary>
    <div class="footerBuffer"></div>
</div>
